@file:OptIn(InternalResourceApi::class)

package helpmycity.shared.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/helpmycity.shared.generated.resources/"

@delegate:ResourceContentHash(2_100_070_063)
internal val Res.string.admin_user_areas: StringResource by lazy {
      StringResource("string:admin_user_areas", "admin_user_areas", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1058, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1006, 64),
      ))
    }

@delegate:ResourceContentHash(2_069_527_571)
internal val Res.string.admin_user_citywide: StringResource by lazy {
      StringResource("string:admin_user_citywide", "admin_user_citywide", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1312, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1220, 47),
      ))
    }

@delegate:ResourceContentHash(-288_262_724)
internal val Res.string.admin_user_citywide_body: StringResource by lazy {
      StringResource("string:admin_user_citywide_body", "admin_user_citywide_body", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1135, 176),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1071, 148),
      ))
    }

@delegate:ResourceContentHash(1_825_062_283)
internal val Res.string.admin_user_departments: StringResource by lazy {
      StringResource("string:admin_user_departments", "admin_user_departments", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1360, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1268, 46),
      ))
    }

@delegate:ResourceContentHash(1_349_506_475)
internal val Res.string.admin_user_districts: StringResource by lazy {
      StringResource("string:admin_user_districts", "admin_user_districts", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1411, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1315, 52),
      ))
    }

@delegate:ResourceContentHash(-393_085_419)
internal val Res.string.admin_user_empty_scope: StringResource by lazy {
      StringResource("string:admin_user_empty_scope", "admin_user_empty_scope", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1468, 142),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1368, 126),
      ))
    }

@delegate:ResourceContentHash(-171_801_695)
internal val Res.string.admin_user_neighborhoods: StringResource by lazy {
      StringResource("string:admin_user_neighborhoods", "admin_user_neighborhoods", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1611, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1495, 52),
      ))
    }

@delegate:ResourceContentHash(-540_727_015)
internal val Res.string.admin_user_no_departments: StringResource by lazy {
      StringResource("string:admin_user_no_departments", "admin_user_no_departments", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1656, 97),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1548, 93),
      ))
    }

@delegate:ResourceContentHash(1_034_344_097)
internal val Res.string.admin_user_no_districts: StringResource by lazy {
      StringResource("string:admin_user_no_districts", "admin_user_no_districts", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1754, 107),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1642, 99),
      ))
    }

@delegate:ResourceContentHash(-1_225_468_543)
internal val Res.string.admin_user_no_neighborhoods: StringResource by lazy {
      StringResource("string:admin_user_no_neighborhoods", "admin_user_no_neighborhoods", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1862, 91),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1742, 95),
      ))
    }

@delegate:ResourceContentHash(1_609_318_684)
internal val Res.string.admin_user_not_found: StringResource by lazy {
      StringResource("string:admin_user_not_found", "admin_user_not_found", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1954, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1838, 76),
      ))
    }

@delegate:ResourceContentHash(1_886_276_183)
internal val Res.string.admin_user_role: StringResource by lazy {
      StringResource("string:admin_user_role", "admin_user_role", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2495, 27),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2307, 31),
      ))
    }

@delegate:ResourceContentHash(1_165_185_739)
internal val Res.string.admin_user_role_admin_note: StringResource by lazy {
      StringResource("string:admin_user_role_admin_note", "admin_user_role_admin_note", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2031, 138),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1915, 102),
      ))
    }

@delegate:ResourceContentHash(-291_497_278)
internal val Res.string.admin_user_role_locked: StringResource by lazy {
      StringResource("string:admin_user_role_locked", "admin_user_role_locked", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2170, 150),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2018, 130),
      ))
    }

@delegate:ResourceContentHash(-1_238_869_390)
internal val Res.string.admin_user_role_resident_note: StringResource by lazy {
      StringResource("string:admin_user_role_resident_note", "admin_user_role_resident_note", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2321, 173),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2149, 157),
      ))
    }

@delegate:ResourceContentHash(1_212_129_560)
internal val Res.string.admin_user_save: StringResource by lazy {
      StringResource("string:admin_user_save", "admin_user_save", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2523, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2339, 43),
      ))
    }

@delegate:ResourceContentHash(1_143_711_826)
internal val Res.string.admin_user_title: StringResource by lazy {
      StringResource("string:admin_user_title", "admin_user_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2575, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2383, 44),
      ))
    }

@delegate:ResourceContentHash(2_029_818_838)
internal val Res.string.admin_users_empty_body: StringResource by lazy {
      StringResource("string:admin_users_empty_body", "admin_users_empty_body", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2616, 198),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2428, 178),
      ))
    }

@delegate:ResourceContentHash(1_449_002_120)
internal val Res.string.admin_users_empty_title: StringResource by lazy {
      StringResource("string:admin_users_empty_title", "admin_users_empty_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2815, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2607, 55),
      ))
    }

@delegate:ResourceContentHash(-1_115_246_478)
internal val Res.string.admin_users_no_areas: StringResource by lazy {
      StringResource("string:admin_users_no_areas", "admin_users_no_areas", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2875, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2663, 52),
      ))
    }

@delegate:ResourceContentHash(651_193_367)
internal val Res.string.admin_users_not_permitted: StringResource by lazy {
      StringResource("string:admin_users_not_permitted", "admin_users_not_permitted", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2932, 137),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2716, 101),
      ))
    }

@delegate:ResourceContentHash(1_096_838_905)
internal val Res.string.admin_users_title: StringResource by lazy {
      StringResource("string:admin_users_title", "admin_users_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3070, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2818, 49),
      ))
    }

@delegate:ResourceContentHash(84_471_546)
internal val Res.string.admin_users_you: StringResource by lazy {
      StringResource("string:admin_users_you", "admin_users_you", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3120, 27),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2868, 27),
      ))
    }

@delegate:ResourceContentHash(758_155_520)
internal val Res.string.app_name: StringResource by lazy {
      StringResource("string:app_name", "app_name", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3148, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2896, 32),
      ))
    }

@delegate:ResourceContentHash(-841_968_928)
internal val Res.string.board_column_count: StringResource by lazy {
      StringResource("string:board_column_count", "board_column_count", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3181, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2929, 34),
      ))
    }

@delegate:ResourceContentHash(-1_961_693_523)
internal val Res.string.board_column_empty: StringResource by lazy {
      StringResource("string:board_column_empty", "board_column_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3216, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2964, 42),
      ))
    }

@delegate:ResourceContentHash(1_103_371_151)
internal val Res.string.board_title: StringResource by lazy {
      StringResource("string:board_title", "board_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3259, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3007, 35),
      ))
    }

@delegate:ResourceContentHash(-1_279_817_875)
internal val Res.string.category_ada_access: StringResource by lazy {
      StringResource("string:category_ada_access", "category_ada_access", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3311, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3043, 43),
      ))
    }

@delegate:ResourceContentHash(-903_893_864)
internal val Res.string.category_drainage: StringResource by lazy {
      StringResource("string:category_drainage", "category_drainage", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3367, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3087, 37),
      ))
    }

@delegate:ResourceContentHash(-564_172_041)
internal val Res.string.category_graffiti: StringResource by lazy {
      StringResource("string:category_graffiti", "category_graffiti", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3405, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3125, 37),
      ))
    }

@delegate:ResourceContentHash(-1_780_594_111)
internal val Res.string.category_other: StringResource by lazy {
      StringResource("string:category_other", "category_other", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3443, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3163, 42),
      ))
    }

@delegate:ResourceContentHash(-1_024_405_969)
internal val Res.string.category_park_maintenance: StringResource by lazy {
      StringResource("string:category_park_maintenance", "category_park_maintenance", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3478, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3206, 57),
      ))
    }

@delegate:ResourceContentHash(149_750_716)
internal val Res.string.category_road_surface: StringResource by lazy {
      StringResource("string:category_road_surface", "category_road_surface", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3544, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3264, 45),
      ))
    }

@delegate:ResourceContentHash(-1_200_810_660)
internal val Res.string.category_sidewalk: StringResource by lazy {
      StringResource("string:category_sidewalk", "category_sidewalk", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3586, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3310, 37),
      ))
    }

@delegate:ResourceContentHash(-471_084_567)
internal val Res.string.category_signage: StringResource by lazy {
      StringResource("string:category_signage", "category_signage", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3624, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3348, 36),
      ))
    }

@delegate:ResourceContentHash(34_627_486)
internal val Res.string.category_street_lighting: StringResource by lazy {
      StringResource("string:category_street_lighting", "category_street_lighting", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3669, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3385, 52),
      ))
    }

@delegate:ResourceContentHash(1_927_703_869)
internal val Res.string.category_traffic_safety: StringResource by lazy {
      StringResource("string:category_traffic_safety", "category_traffic_safety", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3726, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3438, 51),
      ))
    }

@delegate:ResourceContentHash(817_213_059)
internal val Res.string.category_trash_dumping: StringResource by lazy {
      StringResource("string:category_trash_dumping", "category_trash_dumping", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3778, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3490, 62),
      ))
    }

@delegate:ResourceContentHash(-557_180_922)
internal val Res.string.category_water_utilities: StringResource by lazy {
      StringResource("string:category_water_utilities", "category_water_utilities", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3841, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3553, 52),
      ))
    }

@delegate:ResourceContentHash(1_777_254_829)
internal val Res.string.common_cancel: StringResource by lazy {
      StringResource("string:common_cancel", "common_cancel", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3890, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3606, 29),
      ))
    }

@delegate:ResourceContentHash(-742_206_763)
internal val Res.string.common_close: StringResource by lazy {
      StringResource("string:common_close", "common_close", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3924, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3636, 28),
      ))
    }

@delegate:ResourceContentHash(-816_997_011)
internal val Res.string.common_export_csv: StringResource by lazy {
      StringResource("string:common_export_csv", "common_export_csv", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3953, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3665, 41),
      ))
    }

@delegate:ResourceContentHash(1_744_607_709)
internal val Res.string.common_none: StringResource by lazy {
      StringResource("string:common_none", "common_none", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3995, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3707, 27),
      ))
    }

@delegate:ResourceContentHash(440_123_750)
internal val Res.string.common_optional: StringResource by lazy {
      StringResource("string:common_optional", "common_optional", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4027, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3735, 35),
      ))
    }

@delegate:ResourceContentHash(-1_202_696_599)
internal val Res.string.common_save: StringResource by lazy {
      StringResource("string:common_save", "common_save", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4063, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3771, 27),
      ))
    }

@delegate:ResourceContentHash(1_443_816_106)
internal val Res.string.common_unassigned: StringResource by lazy {
      StringResource("string:common_unassigned", "common_unassigned", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4095, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3799, 41),
      ))
    }

@delegate:ResourceContentHash(-962_081_197)
internal val Res.string.continue_as_guest: StringResource by lazy {
      StringResource("string:continue_as_guest", "continue_as_guest", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4137, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3841, 61),
      ))
    }

@delegate:ResourceContentHash(760_500_799)
internal val Res.string.demo_logins_notice: StringResource by lazy {
      StringResource("string:demo_logins_notice", "demo_logins_notice", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4191, 282),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3903, 266),
      ))
    }

@delegate:ResourceContentHash(1_475_149_183)
internal val Res.string.demo_repo_footer: StringResource by lazy {
      StringResource("string:demo_repo_footer", "demo_repo_footer", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4474, 100),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4170, 88),
      ))
    }

@delegate:ResourceContentHash(1_026_724_917)
internal val Res.string.detail_change_status: StringResource by lazy {
      StringResource("string:detail_change_status", "detail_change_status", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4575, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4259, 48),
      ))
    }

@delegate:ResourceContentHash(-833_548_608)
internal val Res.string.detail_coordinates: StringResource by lazy {
      StringResource("string:detail_coordinates", "detail_coordinates", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4628, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4308, 42),
      ))
    }

@delegate:ResourceContentHash(1_377_978_828)
internal val Res.string.detail_department: StringResource by lazy {
      StringResource("string:detail_department", "detail_department", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4671, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4351, 57),
      ))
    }

@delegate:ResourceContentHash(-1_755_316_339)
internal val Res.string.detail_edit: StringResource by lazy {
      StringResource("string:detail_edit", "detail_edit", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4839, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4515, 35),
      ))
    }

@delegate:ResourceContentHash(-763_550_023)
internal val Res.string.detail_edited_by: StringResource by lazy {
      StringResource("string:detail_edited_by", "detail_edited_by", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4729, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4409, 56),
      ))
    }

@delegate:ResourceContentHash(1_419_593_431)
internal val Res.string.detail_edited_fields: StringResource by lazy {
      StringResource("string:detail_edited_fields", "detail_edited_fields", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4786, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4466, 48),
      ))
    }

@delegate:ResourceContentHash(825_390_761)
internal val Res.string.detail_history: StringResource by lazy {
      StringResource("string:detail_history", "detail_history", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4967, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4639, 34),
      ))
    }

@delegate:ResourceContentHash(-542_296_505)
internal val Res.string.detail_history_created: StringResource by lazy {
      StringResource("string:detail_history_created", "detail_history_created", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4879, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4551, 42),
      ))
    }

@delegate:ResourceContentHash(-317_069_278)
internal val Res.string.detail_history_entry: StringResource by lazy {
      StringResource("string:detail_history_entry", "detail_history_entry", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4922, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4594, 44),
      ))
    }

@delegate:ResourceContentHash(-785_004_092)
internal val Res.string.detail_location: StringResource by lazy {
      StringResource("string:detail_location", "detail_location", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5002, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4674, 35),
      ))
    }

@delegate:ResourceContentHash(506_948_393)
internal val Res.string.detail_not_found: StringResource by lazy {
      StringResource("string:detail_not_found", "detail_not_found", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5042, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4710, 72),
      ))
    }

@delegate:ResourceContentHash(-1_192_622_746)
internal val Res.string.detail_notes_source: StringResource by lazy {
      StringResource("string:detail_notes_source", "detail_notes_source", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5115, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4783, 47),
      ))
    }

@delegate:ResourceContentHash(728_541_601)
internal val Res.string.detail_reported_by: StringResource by lazy {
      StringResource("string:detail_reported_by", "detail_reported_by", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5163, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4831, 42),
      ))
    }

@delegate:ResourceContentHash(-1_455_245_777)
internal val Res.string.detail_reported_on: StringResource by lazy {
      StringResource("string:detail_reported_on", "detail_reported_on", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5210, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4874, 46),
      ))
    }

@delegate:ResourceContentHash(-304_618_954)
internal val Res.string.detail_requested_action: StringResource by lazy {
      StringResource("string:detail_requested_action", "detail_requested_action", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5261, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4921, 55),
      ))
    }

@delegate:ResourceContentHash(243_594_613)
internal val Res.string.detail_support: StringResource by lazy {
      StringResource("string:detail_support", "detail_support", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5378, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5030, 46),
      ))
    }

@delegate:ResourceContentHash(431_728_713)
internal val Res.string.detail_supported: StringResource by lazy {
      StringResource("string:detail_supported", "detail_supported", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5317, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4977, 52),
      ))
    }

@delegate:ResourceContentHash(-1_981_790_075)
internal val Res.string.detail_title: StringResource by lazy {
      StringResource("string:detail_title", "detail_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5433, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5077, 28),
      ))
    }

@delegate:ResourceContentHash(1_584_260_706)
internal val Res.string.detail_updated_on: StringResource by lazy {
      StringResource("string:detail_updated_on", "detail_updated_on", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5466, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5106, 41),
      ))
    }

@delegate:ResourceContentHash(-237_799_166)
internal val Res.string.edit_cancel: StringResource by lazy {
      StringResource("string:edit_cancel", "edit_cancel", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5520, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5148, 39),
      ))
    }

@delegate:ResourceContentHash(-1_161_099_330)
internal val Res.string.edit_issue_title: StringResource by lazy {
      StringResource("string:edit_issue_title", "edit_issue_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5564, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5188, 40),
      ))
    }

@delegate:ResourceContentHash(-829_168_376)
internal val Res.string.edit_not_permitted: StringResource by lazy {
      StringResource("string:edit_not_permitted", "edit_not_permitted", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5609, 114),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5229, 106),
      ))
    }

@delegate:ResourceContentHash(-550_638_579)
internal val Res.string.edit_notice: StringResource by lazy {
      StringResource("string:edit_notice", "edit_notice", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5724, 187),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5336, 195),
      ))
    }

@delegate:ResourceContentHash(-1_037_729_254)
internal val Res.string.edit_profile_email: StringResource by lazy {
      StringResource("string:edit_profile_email", "edit_profile_email", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 6000, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5604, 34),
      ))
    }

@delegate:ResourceContentHash(616_312_237)
internal val Res.string.edit_profile_email_hint: StringResource by lazy {
      StringResource("string:edit_profile_email_hint", "edit_profile_email_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5912, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5532, 71),
      ))
    }

@delegate:ResourceContentHash(-450_874_167)
internal val Res.string.edit_profile_name: StringResource by lazy {
      StringResource("string:edit_profile_name", "edit_profile_name", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 6055, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5639, 37),
      ))
    }

@delegate:ResourceContentHash(-1_250_967_049)
internal val Res.string.edit_profile_not_editable: StringResource by lazy {
      StringResource("string:edit_profile_not_editable", "edit_profile_not_editable", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 6093, 117),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5677, 125),
      ))
    }

@delegate:ResourceContentHash(-495_105_580)
internal val Res.string.edit_profile_save: StringResource by lazy {
      StringResource("string:edit_profile_save", "edit_profile_save", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 6211, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5803, 41),
      ))
    }

@delegate:ResourceContentHash(191_470_814)
internal val Res.string.edit_profile_title: StringResource by lazy {
      StringResource("string:edit_profile_title", "edit_profile_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 6257, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5845, 42),
      ))
    }

@delegate:ResourceContentHash(847_255_629)
internal val Res.string.edit_save: StringResource by lazy {
      StringResource("string:edit_save", "edit_save", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 6304, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5888, 33),
      ))
    }

@delegate:ResourceContentHash(1_421_103_291)
internal val Res.string.edited_chip: StringResource by lazy {
      StringResource("string:edited_chip", "edited_chip", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 6342, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5922, 27),
      ))
    }

@delegate:ResourceContentHash(-1_669_969_681)
internal val Res.string.error_email_in_use: StringResource by lazy {
      StringResource("string:error_email_in_use", "error_email_in_use", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 6374, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5950, 82),
      ))
    }

@delegate:ResourceContentHash(1_877_089_328)
internal val Res.string.error_email_taken: StringResource by lazy {
      StringResource("string:error_email_taken", "error_email_taken", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 6449, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6033, 81),
      ))
    }

@delegate:ResourceContentHash(-193_793_424)
internal val Res.string.error_invalid_credentials: StringResource by lazy {
      StringResource("string:error_invalid_credentials", "error_invalid_credentials", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 6523, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6115, 85),
      ))
    }

@delegate:ResourceContentHash(-468_688_417)
internal val Res.string.error_invalid_email: StringResource by lazy {
      StringResource("string:error_invalid_email", "error_invalid_email", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 6609, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6201, 67),
      ))
    }

@delegate:ResourceContentHash(196_602_368)
internal val Res.string.error_name_required: StringResource by lazy {
      StringResource("string:error_name_required", "error_name_required", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 6689, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6269, 47),
      ))
    }

@delegate:ResourceContentHash(1_312_345_695)
internal val Res.string.error_network: StringResource by lazy {
      StringResource("string:error_network", "error_network", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 6741, 97),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6317, 73),
      ))
    }

@delegate:ResourceContentHash(1_609_318_684)
internal val Res.string.error_profile_missing: StringResource by lazy {
      StringResource("string:error_profile_missing", "error_profile_missing", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 6839, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6391, 77),
      ))
    }

@delegate:ResourceContentHash(838_885_036)
internal val Res.string.error_unknown: StringResource by lazy {
      StringResource("string:error_unknown", "error_unknown", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 6917, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6469, 65),
      ))
    }

@delegate:ResourceContentHash(-961_737_556)
internal val Res.string.error_weak_password: StringResource by lazy {
      StringResource("string:error_weak_password", "error_weak_password", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 6991, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6535, 63),
      ))
    }

@delegate:ResourceContentHash(936_117_863)
internal val Res.string.external_last_checked: StringResource by lazy {
      StringResource("string:external_last_checked", "external_last_checked", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 7055, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6599, 53),
      ))
    }

@delegate:ResourceContentHash(2_104_936_026)
internal val Res.string.external_manual_hint: StringResource by lazy {
      StringResource("string:external_manual_hint", "external_manual_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 7109, 176),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6653, 164),
      ))
    }

@delegate:ResourceContentHash(-237_054_999)
internal val Res.string.external_none: StringResource by lazy {
      StringResource("string:external_none", "external_none", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 7286, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6818, 61),
      ))
    }

@delegate:ResourceContentHash(-695_546_954)
internal val Res.string.external_record: StringResource by lazy {
      StringResource("string:external_record", "external_record", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 7360, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6880, 47),
      ))
    }

@delegate:ResourceContentHash(146_012_882)
internal val Res.string.external_reference: StringResource by lazy {
      StringResource("string:external_reference", "external_reference", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 7412, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6928, 50),
      ))
    }

@delegate:ResourceContentHash(-1_208_256_299)
internal val Res.string.external_submitted_on: StringResource by lazy {
      StringResource("string:external_submitted_on", "external_submitted_on", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 7467, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6979, 49),
      ))
    }

@delegate:ResourceContentHash(-831_728_512)
internal val Res.string.external_title: StringResource by lazy {
      StringResource("string:external_title", "external_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 7517, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7029, 30),
      ))
    }

@delegate:ResourceContentHash(647_845_904)
internal val Res.string.field_category: StringResource by lazy {
      StringResource("string:field_category", "field_category", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 7548, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7060, 34),
      ))
    }

@delegate:ResourceContentHash(1_018_094_568)
internal val Res.string.field_department: StringResource by lazy {
      StringResource("string:field_department", "field_department", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 7587, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7095, 40),
      ))
    }

@delegate:ResourceContentHash(-580_842_358)
internal val Res.string.field_description: StringResource by lazy {
      StringResource("string:field_description", "field_description", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 7715, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7235, 41),
      ))
    }

@delegate:ResourceContentHash(-1_742_238_390)
internal val Res.string.field_description_hint: StringResource by lazy {
      StringResource("string:field_description_hint", "field_description_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 7628, 86),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7136, 98),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("admin_user_areas", Res.string.admin_user_areas)
  map.put("admin_user_citywide", Res.string.admin_user_citywide)
  map.put("admin_user_citywide_body", Res.string.admin_user_citywide_body)
  map.put("admin_user_departments", Res.string.admin_user_departments)
  map.put("admin_user_districts", Res.string.admin_user_districts)
  map.put("admin_user_empty_scope", Res.string.admin_user_empty_scope)
  map.put("admin_user_neighborhoods", Res.string.admin_user_neighborhoods)
  map.put("admin_user_no_departments", Res.string.admin_user_no_departments)
  map.put("admin_user_no_districts", Res.string.admin_user_no_districts)
  map.put("admin_user_no_neighborhoods", Res.string.admin_user_no_neighborhoods)
  map.put("admin_user_not_found", Res.string.admin_user_not_found)
  map.put("admin_user_role", Res.string.admin_user_role)
  map.put("admin_user_role_admin_note", Res.string.admin_user_role_admin_note)
  map.put("admin_user_role_locked", Res.string.admin_user_role_locked)
  map.put("admin_user_role_resident_note", Res.string.admin_user_role_resident_note)
  map.put("admin_user_save", Res.string.admin_user_save)
  map.put("admin_user_title", Res.string.admin_user_title)
  map.put("admin_users_empty_body", Res.string.admin_users_empty_body)
  map.put("admin_users_empty_title", Res.string.admin_users_empty_title)
  map.put("admin_users_no_areas", Res.string.admin_users_no_areas)
  map.put("admin_users_not_permitted", Res.string.admin_users_not_permitted)
  map.put("admin_users_title", Res.string.admin_users_title)
  map.put("admin_users_you", Res.string.admin_users_you)
  map.put("app_name", Res.string.app_name)
  map.put("board_column_count", Res.string.board_column_count)
  map.put("board_column_empty", Res.string.board_column_empty)
  map.put("board_title", Res.string.board_title)
  map.put("category_ada_access", Res.string.category_ada_access)
  map.put("category_drainage", Res.string.category_drainage)
  map.put("category_graffiti", Res.string.category_graffiti)
  map.put("category_other", Res.string.category_other)
  map.put("category_park_maintenance", Res.string.category_park_maintenance)
  map.put("category_road_surface", Res.string.category_road_surface)
  map.put("category_sidewalk", Res.string.category_sidewalk)
  map.put("category_signage", Res.string.category_signage)
  map.put("category_street_lighting", Res.string.category_street_lighting)
  map.put("category_traffic_safety", Res.string.category_traffic_safety)
  map.put("category_trash_dumping", Res.string.category_trash_dumping)
  map.put("category_water_utilities", Res.string.category_water_utilities)
  map.put("common_cancel", Res.string.common_cancel)
  map.put("common_close", Res.string.common_close)
  map.put("common_export_csv", Res.string.common_export_csv)
  map.put("common_none", Res.string.common_none)
  map.put("common_optional", Res.string.common_optional)
  map.put("common_save", Res.string.common_save)
  map.put("common_unassigned", Res.string.common_unassigned)
  map.put("continue_as_guest", Res.string.continue_as_guest)
  map.put("demo_logins_notice", Res.string.demo_logins_notice)
  map.put("demo_repo_footer", Res.string.demo_repo_footer)
  map.put("detail_change_status", Res.string.detail_change_status)
  map.put("detail_coordinates", Res.string.detail_coordinates)
  map.put("detail_department", Res.string.detail_department)
  map.put("detail_edit", Res.string.detail_edit)
  map.put("detail_edited_by", Res.string.detail_edited_by)
  map.put("detail_edited_fields", Res.string.detail_edited_fields)
  map.put("detail_history", Res.string.detail_history)
  map.put("detail_history_created", Res.string.detail_history_created)
  map.put("detail_history_entry", Res.string.detail_history_entry)
  map.put("detail_location", Res.string.detail_location)
  map.put("detail_not_found", Res.string.detail_not_found)
  map.put("detail_notes_source", Res.string.detail_notes_source)
  map.put("detail_reported_by", Res.string.detail_reported_by)
  map.put("detail_reported_on", Res.string.detail_reported_on)
  map.put("detail_requested_action", Res.string.detail_requested_action)
  map.put("detail_support", Res.string.detail_support)
  map.put("detail_supported", Res.string.detail_supported)
  map.put("detail_title", Res.string.detail_title)
  map.put("detail_updated_on", Res.string.detail_updated_on)
  map.put("edit_cancel", Res.string.edit_cancel)
  map.put("edit_issue_title", Res.string.edit_issue_title)
  map.put("edit_not_permitted", Res.string.edit_not_permitted)
  map.put("edit_notice", Res.string.edit_notice)
  map.put("edit_profile_email", Res.string.edit_profile_email)
  map.put("edit_profile_email_hint", Res.string.edit_profile_email_hint)
  map.put("edit_profile_name", Res.string.edit_profile_name)
  map.put("edit_profile_not_editable", Res.string.edit_profile_not_editable)
  map.put("edit_profile_save", Res.string.edit_profile_save)
  map.put("edit_profile_title", Res.string.edit_profile_title)
  map.put("edit_save", Res.string.edit_save)
  map.put("edited_chip", Res.string.edited_chip)
  map.put("error_email_in_use", Res.string.error_email_in_use)
  map.put("error_email_taken", Res.string.error_email_taken)
  map.put("error_invalid_credentials", Res.string.error_invalid_credentials)
  map.put("error_invalid_email", Res.string.error_invalid_email)
  map.put("error_name_required", Res.string.error_name_required)
  map.put("error_network", Res.string.error_network)
  map.put("error_profile_missing", Res.string.error_profile_missing)
  map.put("error_unknown", Res.string.error_unknown)
  map.put("error_weak_password", Res.string.error_weak_password)
  map.put("external_last_checked", Res.string.external_last_checked)
  map.put("external_manual_hint", Res.string.external_manual_hint)
  map.put("external_none", Res.string.external_none)
  map.put("external_record", Res.string.external_record)
  map.put("external_reference", Res.string.external_reference)
  map.put("external_submitted_on", Res.string.external_submitted_on)
  map.put("external_title", Res.string.external_title)
  map.put("field_category", Res.string.field_category)
  map.put("field_department", Res.string.field_department)
  map.put("field_description", Res.string.field_description)
  map.put("field_description_hint", Res.string.field_description_hint)
}
